// Icon Registry: Only imports icons actually used in the codebase
// This maintains tree-shaking while providing a centralized icon system

export { Archive as ArchiveIcon } from '@phosphor-icons/react'
export { ArrowCircleLeft as ArrowCircleLeftIcon } from '@phosphor-icons/react'
export { ArrowCircleRight as ArrowCircleRightIcon } from '@phosphor-icons/react'
export { ArrowClockwise as ArrowClockwiseIcon } from '@phosphor-icons/react'
export { ArrowCounterClockwise as ArrowCounterClockwiseIcon } from '@phosphor-icons/react'
export { ArrowDown as ArrowDownIcon } from '@phosphor-icons/react'
export { ArrowLeft as ArrowLeftIcon } from '@phosphor-icons/react'
export { ArrowLineUp as ArrowLineUpIcon } from '@phosphor-icons/react'
export { ArrowsClockwise as ArrowsClockwiseIcon } from '@phosphor-icons/react'
export { ArrowsDownUp as ArrowsDownUpIcon } from '@phosphor-icons/react'
export { ArrowsIn as ArrowsInIcon } from '@phosphor-icons/react'
export { ArrowsLeftRight as ArrowsLeftRightIcon } from '@phosphor-icons/react'
export { ArrowsMerge as ArrowsMergeIcon } from '@phosphor-icons/react'
export { ArrowsOut as ArrowsOutIcon } from '@phosphor-icons/react'
export { ArrowsOutLineVertical as ArrowsOutLineVerticalIcon } from '@phosphor-icons/react'
export { ArrowSquareOut as ArrowSquareOutIcon } from '@phosphor-icons/react'
export { ArrowUp as ArrowUpIcon } from '@phosphor-icons/react'
export { Article as ArticleIcon } from '@phosphor-icons/react'
export { Barcode as BarcodeIcon } from '@phosphor-icons/react'
export { Bell as BellIcon } from '@phosphor-icons/react'
export { Blueprint as BlueprintIcon } from '@phosphor-icons/react'
export { BookOpenText as BookOpenTextIcon } from '@phosphor-icons/react'
export { Calculator as CalculatorIcon } from '@phosphor-icons/react'
export { CalendarBlank as CalendarBlankIcon } from '@phosphor-icons/react'
export { CalendarDot as CalendarDotIcon } from '@phosphor-icons/react'
export { CalendarDots as CalendarDotsIcon } from '@phosphor-icons/react'
export { CalendarX as CalendarXIcon } from '@phosphor-icons/react'
export { Car as CarIcon } from '@phosphor-icons/react'
export { CaretDoubleLeft as CaretDoubleLeftIcon } from '@phosphor-icons/react'
export { CaretDoubleRight as CaretDoubleRightIcon } from '@phosphor-icons/react'
export { CaretDown as CaretDownIcon } from '@phosphor-icons/react'
export { CaretLeft as CaretLeftIcon } from '@phosphor-icons/react'
export { CaretRight as CaretRightIcon } from '@phosphor-icons/react'
export { CaretUp as CaretUpIcon } from '@phosphor-icons/react'
export { CarSimple as CarSimpleIcon } from '@phosphor-icons/react'
export { ChartBar as ChartBarIcon } from '@phosphor-icons/react'
export { ChartDonut as ChartDonutIcon } from '@phosphor-icons/react'
export { ChatDots as ChatDotsIcon } from '@phosphor-icons/react'
export { Check as CheckIcon } from '@phosphor-icons/react'
export { Check as CheckIconSimple } from '@phosphor-icons/react'
export { CheckCircle as CheckCircleIcon } from '@phosphor-icons/react'
export { Circle as CircleIcon } from '@phosphor-icons/react'
export { CircleNotch as CircleNotchIcon } from '@phosphor-icons/react'
export { Clock as ClockIcon } from '@phosphor-icons/react'
export { ClockClockwise as ClockClockwiseIcon } from '@phosphor-icons/react'
export { ClockCountdown as ClockCountdownIcon } from '@phosphor-icons/react'
export { CloudRain as CloudRainIcon } from '@phosphor-icons/react'
export { Compass as CompassIcon } from '@phosphor-icons/react'
export { Copy as CopyIcon } from '@phosphor-icons/react'
export { CurrencyCircleDollar as CurrencyCircleDollarIcon } from '@phosphor-icons/react'
export { DotsSix as DotsSixIcon } from '@phosphor-icons/react'
export { DotsSixVertical as DotsSixVerticalIcon } from '@phosphor-icons/react'
export { DotsThree as DotsThreeIcon } from '@phosphor-icons/react'
export { DotsThreeVertical as DotsThreeVerticalIcon } from '@phosphor-icons/react'
export { DownloadSimple as DownloadSimpleIcon } from '@phosphor-icons/react'
export { Envelope as EnvelopeIcon } from '@phosphor-icons/react'
export { Export as ExportIcon } from '@phosphor-icons/react'
export { Eye as EyeIcon } from '@phosphor-icons/react'
export { FadersHorizontal as FadersHorizontalIcon } from '@phosphor-icons/react'
export { FileArrowDown as FileArrowDownIcon } from '@phosphor-icons/react'
export { FilePdf as FilePdfIcon } from '@phosphor-icons/react'
export { Files as FilesIcon } from '@phosphor-icons/react'
export { FileX as FileXIcon } from '@phosphor-icons/react'
export { Flag as FlagIcon } from '@phosphor-icons/react'
export { FolderSimplePlus as FolderSimplePlusIcon } from '@phosphor-icons/react'
export { Funnel as FunnelIcon } from '@phosphor-icons/react'
export { FunnelSimple as FunnelSimpleIcon } from '@phosphor-icons/react'
export { Garage as GarageIcon } from '@phosphor-icons/react'
export { Gauge as GaugeIcon } from '@phosphor-icons/react'
export { GearSix as GearSixIcon } from '@phosphor-icons/react'
export { Globe as GlobeIcon } from '@phosphor-icons/react'
export { GlobeHemisphereWest as GlobeHemisphereWestIcon } from '@phosphor-icons/react'
export { Graph as GraphIcon } from '@phosphor-icons/react'
export { HandHeart as HandHeartIcon } from '@phosphor-icons/react'
export { HandsClapping as HandsClappingIcon } from '@phosphor-icons/react'
export { Heart as HeartIcon } from '@phosphor-icons/react'
export { Heartbeat as HeartbeatIcon } from '@phosphor-icons/react'
export { HourglassHigh as HourglassHighIcon } from '@phosphor-icons/react'
export { HourglassLow as HourglassLowIcon } from '@phosphor-icons/react'
export { House as HouseIcon } from '@phosphor-icons/react'
export { HouseLine as HouseLineIcon } from '@phosphor-icons/react'
export { Info as InfoIcon } from '@phosphor-icons/react'
export { Link as LinkIcon } from '@phosphor-icons/react'
export { ListBullets as ListBulletsIcon } from '@phosphor-icons/react'
export { ListDashes as ListDashesIcon } from '@phosphor-icons/react'
export { ListNumbers as ListNumbersIcon } from '@phosphor-icons/react'
export { LockSimple as LockSimpleIcon } from '@phosphor-icons/react'
export { MagnifyingGlass as MagnifyingGlassIcon } from '@phosphor-icons/react'
export { MapPin as MapPinIcon } from '@phosphor-icons/react'
export { MapPinArea as MapPinAreaIcon } from '@phosphor-icons/react'
export { MapPinLine as MapPinLineIcon } from '@phosphor-icons/react'
export { MapPinSimple as MapPinSimpleIcon } from '@phosphor-icons/react'
export { MapTrifold as MapTrifoldIcon } from '@phosphor-icons/react'
export { Megaphone as MegaphoneIcon } from '@phosphor-icons/react'
export { Moon as MoonIcon } from '@phosphor-icons/react'
export { NavigationArrow as NavigationArrowIcon } from '@phosphor-icons/react'
export { NotePencil as NotePencilIcon } from '@phosphor-icons/react'
export { Package as PackageIcon } from '@phosphor-icons/react'
export { PaperPlaneTilt as PaperPlaneTiltIcon } from '@phosphor-icons/react'
export { Path as PathIcon } from '@phosphor-icons/react'
export { PencilSimple as PencilSimpleIcon } from '@phosphor-icons/react'
export { PencilSimpleLine as PencilSimpleLineIcon } from '@phosphor-icons/react'
export { PenNib as PenNibIcon } from '@phosphor-icons/react'
export { PersonSimpleRun as PersonSimpleRunIcon } from '@phosphor-icons/react'
export { Phone as PhoneIcon } from '@phosphor-icons/react'
export { Plus as PlusIcon } from '@phosphor-icons/react'
export { PlusCircle as PlusCircleIcon } from '@phosphor-icons/react'
export { Prohibit as ProhibitIcon } from '@phosphor-icons/react'
export { Pulse as PulseIcon } from '@phosphor-icons/react'
export { Question as QuestionIcon } from '@phosphor-icons/react'
export { Receipt as ReceiptIcon } from '@phosphor-icons/react'
export { ReceiptX as ReceiptXIcon } from '@phosphor-icons/react'
export { Repeat as RepeatIcon } from '@phosphor-icons/react'
export { RoadHorizon as RoadHorizonIcon } from '@phosphor-icons/react'
export { SealCheck as SealCheckIcon } from '@phosphor-icons/react'
export { SelectionPlus as SelectionPlusIcon } from '@phosphor-icons/react'
export { ShareFat as ShareFatIcon } from '@phosphor-icons/react'
export { ShieldWarning as ShieldWarningIcon } from '@phosphor-icons/react'
export { SignIn as SignInIcon } from '@phosphor-icons/react'
export { SignOut as SignOutIcon } from '@phosphor-icons/react'
export { Sliders as SlidersIcon } from '@phosphor-icons/react'
export { SlidersHorizontal as SlidersHorizontalIcon } from '@phosphor-icons/react'
export { Smiley as SmileyIcon } from '@phosphor-icons/react'
export { Sparkle as SparkleIcon } from '@phosphor-icons/react'
export { Spinner as SpinnerIcon } from '@phosphor-icons/react'
export { Square as SquareIcon } from '@phosphor-icons/react'
export { StarFour as StarFourIcon } from '@phosphor-icons/react'
export { SteeringWheel as SteeringWheelIcon } from '@phosphor-icons/react'
export { Tag as TagIcon } from '@phosphor-icons/react'
export { ThumbsDown as ThumbsDownIcon } from '@phosphor-icons/react'
export { ThumbsUp as ThumbsUpIcon } from '@phosphor-icons/react'
export { Timer as TimerIcon } from '@phosphor-icons/react'
export { Tractor as TractorIcon } from '@phosphor-icons/react'
export { Trash as TrashIcon } from '@phosphor-icons/react'
export { TrendUp as TrendUpIcon } from '@phosphor-icons/react'
export { Truck as TruckIcon } from '@phosphor-icons/react'
export { TruckTrailer as TruckTrailerIcon } from '@phosphor-icons/react'
export { User as UserIcon } from '@phosphor-icons/react'
export { UserCircle as UserCircleIcon } from '@phosphor-icons/react'
export { UserCircleGear as UserCircleGearIcon } from '@phosphor-icons/react'
export { UserGear as UserGearIcon } from '@phosphor-icons/react'
export { Users as UsersIcon } from '@phosphor-icons/react'
export { UsersFour as UsersFourIcon } from '@phosphor-icons/react'
export { UserSquare as UserSquareIcon } from '@phosphor-icons/react'
export { UserSwitch as UserSwitchIcon } from '@phosphor-icons/react'
export { Warehouse as WarehouseIcon } from '@phosphor-icons/react'
export { Warning as WarningIcon } from '@phosphor-icons/react'
export { WarningCircle as WarningCircleIcon } from '@phosphor-icons/react'
export { X as XIcon } from '@phosphor-icons/react'

// Type for all available icon names
export type IconName =
  keyof typeof import('~/src/components/generic/PhosphorIcons/iconRegistry')
